import { CircleCheck } from 'lucide-react';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  /** Names what is missing. */
  title: string;
  /** What to do about it (or, for a success tone, why nothing is wrong). */
  description: string;
  /** The one thing to do about it. */
  action?: ReactNode;
  /** `success` is a healthy-empty widget ("No failures this week"): a check icon, the title kept. */
  tone?: 'neutral' | 'success';
}

/** Centered "nothing here" block, the only empty block (DESIGN.md §11.2). */
export function EmptyState({
  icon,
  title,
  description,
  action,
  tone = 'neutral',
}: EmptyStateProps) {
  const success = tone === 'success';
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
      {success ? (
        <div className="text-success-600 dark:text-success-400">
          {icon ?? <CircleCheck className="size-8" aria-hidden="true" />}
        </div>
      ) : (
        icon && <div className="text-gray-400 dark:text-gray-500">{icon}</div>
      )}
      <p className="text-sm font-medium text-gray-800 dark:text-white/90">{title}</p>
      <p className="text-sm text-gray-500 dark:text-gray-400">{description}</p>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
